"use strict";

var LetterpressComponent = require('../products/interfaces/LetterpressComponent');

var Envelope = require('../products/interfaces/Envelope');

var _require = require('../products/components'),
    BasicBookletProgram = _require.BasicBookletProgram,
    DeluxeBookletProgramCover = _require.DeluxeBookletProgramCover,
    DeluxeBookletProgramInterior = _require.DeluxeBookletProgramInterior,
    FlatBookletProgram = _require.FlatBookletProgram,
    EnvelopeLiner = _require.EnvelopeLiner,
    EuroFlapEnvelopeLiner = _require.EuroFlapEnvelopeLiner,
    PlaceCard = _require.PlaceCard,
    SquareProgram = _require.SquareProgram,
    TableNumber = _require.TableNumber,
    ThankYouCard = _require.ThankYouCard,
    Wrapper = _require.Wrapper,
    MediumWrapper = _require.MediumWrapper,
    ThickWrapper = _require.ThickWrapper;

function isLetterpressComponent(component) {
  return Object.prototype.isPrototypeOf.call(LetterpressComponent.prototype, component);
}

function excludeFromLetterpress(component) {
  return [Envelope, Wrapper, MediumWrapper, ThickWrapper, EnvelopeLiner, EuroFlapEnvelopeLiner].some(function (Constructor) {
    return Object.prototype.isPrototypeOf.call(Constructor.prototype, component);
  });
}

function excludeFromDoubleThick(component) {
  return [BasicBookletProgram, DeluxeBookletProgramCover, DeluxeBookletProgramInterior, FlatBookletProgram, EnvelopeLiner, EuroFlapEnvelopeLiner, PlaceCard, SquareProgram, TableNumber, ThankYouCard, Wrapper, MediumWrapper, ThickWrapper, Envelope].some(function (Constructor) {
    return Object.prototype.isPrototypeOf.call(Constructor.prototype, component);
  });
}

module.exports = {
  isLetterpressComponent: isLetterpressComponent,
  excludeFromLetterpress: excludeFromLetterpress,
  excludeFromDoubleThick: excludeFromDoubleThick
};